import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ValidationProjectsComponent } from './components/validation-projects/validation-projects.component';

const routes: Routes = [{path: '', component: ValidationProjectsComponent}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ValidationProjectsRoutingModule { }
